module.exports = __webpack_public_path__ + "img/logo.f7da8b04.png";